<div class="modal-header">
  <h5 class="modal-title">
    <i *ngIf="data.icon" [class]="data.icon"></i>
    {{ data.label }}
  </h5>
  <button (click)="close()" type="button" class="close" aria-label="Close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body pb-0">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-sm-12">
        <div class="primary-item mb-3">
          <ng-container i18n>Primary</ng-container> {{ data.itemLabel }}: <strong>{{ data.primaryItem() }}</strong>
        </div>
      </div>

      <table class="table mb-0">
        <thead>
          <tr>
            <th scope="col">{{ data.itemLabel }}</th>
            <th scope="col" class="fit" i18n>Mark as Primary</th>
            <th scope="col" class="fit" i18n>Remove</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of data.items(); let i = index">
            <tr>
              <td>
                <mat-form-field2 class="mat-block" [showLabel]="false">
                  <input type="text" matInput value="{{ item }}" placeholder="{{ data.itemLabel }}" readonly />
                </mat-form-field2>
              </td>
              <td class="text-center">
                <button
                  (click)="makePrimaryOldItem(i)"
                  [matTooltip]="item == data.primaryItem() ? '' : data.makePrimaryLabel"
                  matTooltipPosition="above"
                  type="button"
                  class="btn btn-light position-relative"
                  [disabled]="item == data.primaryItem()"
                >
                  <i [class]="item == data.primaryItem() ? 'fas text-primary' : 'far'" class="fa-thumbtack"></i>
                  <span *ngIf="item == data.primaryItem()" class="suffix-primary text-xs" i18n> Primary </span>
                </button>
              </td>
              <td class="text-center">
                <button (click)="removeOldItem(i)" class="btn btn-light-danger" type="button">
                  <i class="far fa-minus-circle"></i>
                </button>
              </td>
            </tr>
          </ng-container>
          <ng-container formArrayName="newItems">
            <tr *ngFor="let item of newItems.controls; let i = index">
              <ng-template #emailField>
                <mat-form-field2 class="mat-block" [class]="item.hasError('email') ? 'mb-2' : ''" [showLabel]="false">
                  <input type="email" matInput [formControl]="item" placeholder="{{ data.itemLabel }}" />
                  <mat-error i18n *ngIf="item.hasError('email')"> Email must have valid format </mat-error>
                </mat-form-field2>
              </ng-template>

              <td [formGroupName]="i">
                <app-phone-number-input
                  [ctrl]="item"
                  [showLabel]="false"
                  *ngIf="data.type === 'phone'; else emailField"
                  class="d-block mb-2"
                ></app-phone-number-input>
              </td>
              <td class="text-center">
                <button
                  [matTooltip]="item.invalid || !item.value ? 'Enter valid value' : data.makePrimaryLabel"
                  [disabled]="item.invalid || !item.value"
                  (click)="makePrimaryNewItem(i)"
                  matTooltipPosition="above"
                  type="button"
                  class="btn btn-light position-relative"
                >
                  <i class="far fa-thumbtack"></i>
                </button>
              </td>
              <td class="text-center">
                <button (click)="removeNewItem(i)" class="btn btn-light-danger" type="button">
                  <i class="far fa-minus-circle"></i>
                </button>
              </td>
            </tr>
          </ng-container>
          <tr>
            <td colspan="3">
              <button (click)="addNewItem()" class="btn btn-light-primary" type="button">
                <i class="far fa-plus"></i>
                {{ data.newItemLabel }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="save(form)" type="button" class="btn btn-secondary-info create-btn">
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>save</ng-container>
  </button>
</div>
